/**
 * B403 #28 (75:2) — the journey planner is retired from the booking face:
 * routes are CARDS like every other product (one card per product, each with
 * its own caps CTA), and the ONE planner fact that still needs a control —
 * one way or round trip — lives INSIDE a route card's own walk as this
 * segmented pill. App renders it only where the catalog honestly sells the
 * reverse O-D (returnCardFor answers), so the pill itself has no disabled
 * face and contributes no button — the walk's doors stay the departure chips.
 */
import type { ReactElement } from "react";
import { SegmentedControl } from "@transact/ui";

export function TripTypeChoice(props: {
  readonly roundTrip: boolean;
  readonly onChange: (roundTrip: boolean) => void;
}): ReactElement {
  return (
    <div className="trip-type">
      <SegmentedControl
        legend="Trip type"
        name="trip-type"
        options={[
          { value: "one-way", label: "One way" },
          { value: "round", label: "Round trip" },
        ]}
        value={props.roundTrip ? "round" : "one-way"}
        onChange={(picked) => props.onChange(picked === "round")}
      />
    </div>
  );
}
